// @ai-generated 2026-09-14T00:00:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useToasts } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useClientNavigate } from '../../Routing/useClientNavigate';

const RUN_TOAST_TIMEOUT_MS = 30_000;

/**
 * Reports a started workflow and offers the list it will show up in.
 */
export function useOfferStartedRun() {
    const navigate = useClientNavigate();
    const { pushToast, remove } = useToasts();

    const offerStartedRun = useCallback(
        (workflowTitle: string) => {
            let toastId = '';
            toastId = pushToast({
                title: `${workflowTitle} gestartet`,
                message: 'Der Lauf läuft im Hintergrund weiter.',
                variant: 'success',
                timeout: RUN_TOAST_TIMEOUT_MS,
                actions: [
                    {
                        id: 'open_runs',
                        label: 'Läufe ansehen',
                        variant: 'success',
                        onClick: () => {
                            remove(toastId);
                            navigate('/settings/workflow_runs/list');
                        },
                    },
                ],
            });
        },
        [navigate, pushToast, remove],
    );

    return { offerStartedRun };
}
